import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cn } from '@/lib/utils';

function Label({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'flex items-center justify-between gap-2 text-xs font-semibold text-foreground/80 select-none',
        className,
      )}
      {...props}
    />
  );
}

export { Label };
